import axios from "../axios-auth";

export const financeSessionService = {
    getAllFinanceSession,
    saveFinanceSession,
    getFinanceSessionDetail,
    runProcess,
    reverseProcess
}

function getAllFinanceSession(searchParams, page, size, sortBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    } if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortBy
    };
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.yearMonth) {
        params["yearMonth"] = searchParams.yearMonth;
    }
    return axios.get("/auth/finance-session", { params })
}

function saveFinanceSession(financeSession) {
    if (!financeSession.id) {
        // new finance session
        return axios.post("/auth/finance-session", financeSession);
    } else {
        // edit
        return axios.put("/auth/finance-session", financeSession);
    }
}

function getFinanceSessionDetail(id) {
    return axios.get("/auth/finance-session/" + id);
}

function runProcess(id) {
    return axios.post("/auth/finance-session/process-for-gl", id, { timeout: 2000000 });
}

function reverseProcess(id) {
    return axios.delete("/auth/finance-session/" + id);
}
